function initMaps() {
	if ($('#full-map').length ) {
		$('#full-map').mcubeGmaps({
			bounds:  true, // default : true
			overlay: true, // default : true
			styles:  [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
		});
	}
}

$.fn.mcubeGmaps = function( options ){

	var defauts = {
		bounds:  true, // active le centrage automatiquement de la map afin d'afficher tous les points dans le viewport
		overlay: true, // active l'apparition de la 'popup' au click sur le pointeur
		styles : null  // personnalisation des styles la map
	};

	var parametres = $.extend(defauts, options);

	if( typeof GMaps == "undefined" ){
		console.log( 'ERREUR GMAPS : activer GMaps dans functions.php' );
	}

	return this.each(function() {

		var $map         = $(this);
		var map          = false;
		var mapLat       = $map.data('lat');
		var mapLng       = $map.data('lng');
		var mapZoom      = ( $map.data('zoom') || 12 );
		var markers      = $('.map-markers', $map);
		var pointerColor = $map.data('pointer-color');
		var bounds       = null;

		if( !mapLat ){
			console.log( 'ERREUR GMAPS : définir une latitude (data-lat)' );
		}

		if( !mapLng ){
			console.log( 'ERREUR GMAPS : définir une longitude (data-lng)' );
		}

		if( markers.length == 0 ){
			console.log( 'ERREUR GMAPS : aucun point de défini' );
			console.log( '<div class="map-markers" data-lat="" data-lng=""> contenu html </div>' );
		}

		if( parametres.bounds ){
			bounds = new google.maps.LatLngBounds();
		}

		map = new GMaps({
			div:         "."+$(this).attr('class'),
			zoom:        mapZoom,
			// maxZoom:     13,
			lat:         mapLat,
			lng:         mapLng,
			scrollwheel: false,
			zoomControl: true,
			panControl : false,
			options: {
				'styles': parametres.styles
			}
		});

		/// Fonctions au resize pour recentrer la map
		google.maps.event.addDomListener(window, 'resize', function() {
			if( parametres.overlay ){
				//map.setCenter(marker_lat, marker_lng);

			} else if ( parametres.bounds ){
				map.panToBounds(bounds);
				map.fitBounds(bounds);

			} else {
				map.setCenter(mapLat, mapLng );
			}
		});

		/// Personnalisation du pointer
		if( pointerColor ){

			var icon = {
				path: "M49.1,49.1c-6.5,6.5-17.1,6.5-23.6,0s-6.5-17.1,0-23.6s17.1-6.5,23.6,0S55.6,42.6,49.1,49.1 M63.6,10.9c-14.6-14.6-38.2-14.6-52.7,0s-14.6,38.2,0,52.7L37.3,90l26.4-26.4C78.2,49.1,78.2,25.5,63.6,10.9",
				fillColor:  pointerColor,
				fillOpacity: 1,
				anchor:     new google.maps.Point( 50, 100 ),
				strokeWeight: 0,
				scale: 0.35,
				origin:     new google.maps.Point( 0 , 0 ),
			};

		}

		/// Ajout des markers
		$.each(markers, function(i,program){

			$this           = $(this);
			var custom_icon = null;

			if( $this.data('pointer') ){

				var custom_icon_url  = $this.data('pointer');
				var custom_icon_size = $this.data('pointer-size');

				custom_icon          = {
					url:        custom_icon_url,
					size:       new google.maps.Size( imageWidth , imageHeight ),
					origin:     new google.maps.Point( 0 , 0 ),
					anchor:     new google.maps.Point( imageWidth/2 , imageHeight ),
					scaledSize: new google.maps.Size( imageWidth , imageHeight )
				};

			}

			var myMarker = map.addMarker({
				id:       $this.data('id'),
				lat:      $this.data('lat'),
				lng:      $this.data('lng'),
				title:    $this.data('title'),
				link:     $this.data('url'),
				linkText: $this.data('url-text'),
				address:  $this.data('address'),
				phone:    $this.data('phone'),
				icon:     ( custom_icon || icon ),
				click:    function(element){
					if( parametres.overlay ){
						mapLoadOverlay(element);
					}
				}
			});

			if( parametres.bounds ){
				bounds.extend( myMarker.getPosition() );
				markers.push( myMarker );
			}

		});

		/// Recentre la map pour afficher tous les markers dans le viewport
		if( parametres.bounds ){
			map.panToBounds(bounds);
			map.fitBounds(bounds);
			setTimeout( function() {
				if ( map.getZoom() > 13) {
					map.setZoom(13);
				}
			}, 200 );
		}

		/// Affichage des infos bulles
		function mapLoadOverlay(element) {

			overlay = true;

			marker     = element;
			position   = marker.getPosition();
			marker_lat = position.lat();
			marker_lng = position.lng();

			contenu = '<div class="map-overlay"><div class="map-overlay-content"><a href="#" class="map-overlay-close">&times;</a>';
			contenu += '<div class="map-overlay-inner"><span class="title">'+marker.title+'</span>'+marker.address+'<br><span class="phone">'+marker.phone+'</span><a href="'+marker.link+'" class="link">'+marker.linkText+'</a></div>';
			contenu += '</div></div>';

			map.removeOverlays();

			map.setCenter(marker_lat, marker_lng);

			var imgLoad = imagesLoaded( $(contenu) );
			imgLoad.on( 'always', function() {
				map.drawOverlay({
					lat:              marker_lat,
					lng:              marker_lng,
					verticalAlign:    'center',
					horizontalOffset: 20,
					layer:            'floatPane',
					content:          contenu
				});
			});

			$('.map-overlay a:not(.map-overlay-close)').unbind('click').click(function(e) {
				e.preventDefault();
				linkHandler( $(this) );
			});

			$(document).on('click touchstart', '.map-overlay-close', function(e) {
				e.preventDefault();
				map.removeOverlays();
				overlay = false;

				if( parametres.bounds ){
					map.panToBounds(bounds);
					map.fitBounds(bounds);
				}
			});
		}
	});
};